module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0061.jpg?v=b88f264b";